import { useState } from "react";
import { icons } from "../assets/icons/icons";
import { useSound } from "../components/SoundHandler";
import { ContainerShape, HexagonShape, InnerShape } from "../components/Shape";
import { useError } from "~/core/contexts/ErrorContext";
import Loader from "~/core/components/Loader";
import { useAccount } from "wagmi";
import { api } from "../api";

export const SelfExclusionModal = ({ onDismiss }: { onDismiss: () => void }) => {
  const sounds = useSound()
  const { handleError } = useError()
  const { address } = useAccount()

  const [isLoading, setIsLoading] = useState(false)

  const OPTIONS: { label: string; seconds: number }[] = [
    { label: '1 day', seconds: 24 * 60 * 60 },
    { label: '1 week', seconds: 7 * 24 * 60 * 60 },
    { label: '1 month', seconds: 30 * 24 * 60 * 60 },
    { label: '3 months', seconds: 90 * 24 * 60 * 60 },
    { label: '6 months', seconds: 180 * 24 * 60 * 60 },
    { label: '1 year', seconds: 365 * 24 * 60 * 60 },
  ]

  const [selectedSeconds, setSelectedSeconds] = useState<number | null>(null)

  const onClose = () => {
    onDismiss()
    sounds.play('click')
  };

  const handleSelect = (seconds: number) => {
    setSelectedSeconds(seconds)
    sounds.play('click')
  }


  const onConfirm = async () => {
    if (selectedSeconds == null) return
    sounds.play('click')
    setIsLoading(true)

    try {
      await api.setRestriction(address!, selectedSeconds)
      onDismiss()
    } catch (error) {
      handleError('Failed to self exclude', error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-[#18181B]/50">
      
      <div>
        <ContainerShape {...{cornerDiagonal: 20, cornerRadius: 8, strokeWidth: 2 }}>
          <div className="p-6 w-[350px] md:w-[448px]">
            <div className="flex flex-row justify-between">
              <div className="mt-1 text-2xl font-blinko font-black text-white">
                Self Exclusion
              </div>

               <button className="" onClick={onClose}>
                <HexagonShape cornerRadius={6} strokeWidth={1}>
                  <div className="flex justify-center items-center p-2">
                    <img src={icons.close} className='w-6 h-6' />
                  </div>
                </HexagonShape>
              </button>
              
            </div>
            
            <p className="text-sm text-red-500 mt-3">
              WARNING: THIS WILL BAN YOU FROM PLAYING BLINKO FOR THE SET PERIOD OF TIME
            </p>
            
            <p className="text-sm text-white/70 mt-2">
              {selectedSeconds == null ? (
                <>
                  Please select a duration.
                  
                </>
              ) : (
                <>Are you sure you want to self exclude for {OPTIONS.find(o => o.seconds === selectedSeconds)!.label}?</>
              )}
            </p>

            {selectedSeconds == null && (
              <div role="radiogroup" aria-label="Self exclusion duration" className="mt-4 grid grid-cols-2 sm:grid-cols-3 gap-2">
              {OPTIONS.map((opt) => {
                const isActive = selectedSeconds === opt.seconds
                return (
                  <button
                    key={opt.seconds}
                    role="radio"
                    aria-checked={isActive}
                    onClick={() => handleSelect(opt.seconds)}
                    className="w-full"
                  >
                    <div className="rounded" style={{ border: '1px solid #FFF08550'}}>
                        <div className="p-2 bg-[#F0B10030]">
                          <p className="text-xs font-semibold text-white">
                            {opt.label}
                          </p>
                        </div>
                      </div>
                  </button>
                  )
                })}
              </div>
            )}

            {selectedSeconds != null && (
              <div className="mt-6 flex justify-end space-x-2">
                <button onClick={onConfirm}>
                  <InnerShape cornerDiagonal={14} cornerRadius={8} strokeWidth={1}>
                    <div className="relative px-6 py-3">
                      <p 
                        className="text-sm font-blinko text-white"
                        style={{
                          opacity: isLoading ? 0 : 1
                        }}
                      >
                        Confirm
                      </p>
                      {isLoading && (
                        <div className="absolute inset-0 flex items-center justify-center">
                          <Loader stroke="white" size="16px" />
                        </div>
                      )}
                    </div>
                  </InnerShape>
                </button>
              </div>
            )}

        </div>
        
        </ContainerShape>
      </div>
    </div>
  );
};
